import { TEMPLATE_TYPES } from './constants';

export const TEMPLATE_TYPES_DATA = {
  [TEMPLATE_TYPES.SYSTEM]: {
    id: TEMPLATE_TYPES.SYSTEM,
  },
  [TEMPLATE_TYPES.USER]: {
    id: TEMPLATE_TYPES.USER,
  },
  [TEMPLATE_TYPES.NULL]: {
    id: TEMPLATE_TYPES.NULL,
  },
  [TEMPLATE_TYPES.FORMAT_A4]: {
    id: TEMPLATE_TYPES.FORMAT_A4,
    name: 'Формат А4',
    local: true,
    template: {
      frame: {
        width: 794,
        height: 1123,
        content: [],
      },
    },
  },
};

export const SERVER_TEMPLATE_TYPES_LIST = Object.values(TEMPLATE_TYPES_DATA).filter((i) => !i.local);
export const LOCAL_TEMPLATE_TYPES_LIST = Object.values(TEMPLATE_TYPES_DATA).filter((i) => i.local);

export default {
  TEMPLATE_TYPES_DATA,

  SERVER_TEMPLATE_TYPES_LIST,
  LOCAL_TEMPLATE_TYPES_LIST,
};
